import React from 'react';
import { 
  Box, 
  Card, 
  CardContent, 
  Typography, 
  OutlinedInput, 
  Select, 
  InputLabel,
  Button,
  Container,
  Paper,
  BoxProps,
  CardProps,
  TypographyProps,
  OutlinedInputProps,
  SelectProps,
  InputLabelProps,
  ButtonProps,
  ContainerProps,
  PaperProps
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors, borderRadius, spacing } from '../../theme';

// Background com cor sólida
export const GradientBackground = styled(Box)<BoxProps>(() => ({
  background: colors.primary.main,
  alignItems: 'center',
  display: 'flex',
  flexGrow: 1,
  minHeight: '100vh',
  position: 'relative',
}));

// Container centralizado
export const CenteredContainer = styled(Container)<ContainerProps>(() => ({
  position: 'relative',
  zIndex: 1,
}));

// Card estilizado
export const GlassCard = styled(Card)<CardProps>(() => ({
  borderRadius: borderRadius.large,
  boxShadow: 'none',
  background: colors.background.paper,
  border: '1px solid #e0e0e0',
  position: 'relative',
  zIndex: 1,
}));

// Card content com padding customizado
export const StyledCardContent = styled(CardContent)(() => ({
  padding: spacing.xl,
}));

// Logo circular
interface LogoCircleProps {
  children: React.ReactNode;
}

export const LogoCircle = styled(Box)<LogoCircleProps>(() => ({
  width: 80,
  height: 80,
  borderRadius: borderRadius.circle,
  background: colors.primary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: `0 auto ${spacing.lg}`,
  boxShadow: 'none',
  fontSize: '32px',
  color: 'white',
  fontWeight: 'bold',
}));

// Título estilizado
export const GradientTitle = styled(Typography)<TypographyProps>(() => ({
  fontWeight: 700,
  color: colors.primary.main,
  textAlign: 'center',
  marginBottom: spacing.sm,
}));

// Subtítulo estilizado
export const StyledSubtitle = styled(Typography)<TypographyProps>(() => ({
  fontWeight: 500,
  color: 'text.secondary',
  textAlign: 'center',
  marginBottom: spacing.lg,
}));

// Label personalizada
export const StyledInputLabel = styled(InputLabel)<InputLabelProps>(() => ({
  marginBottom: spacing.sm,
  fontWeight: 600,
  color: 'text.primary',
}));

// Input estilizado
export const StyledInput = styled(OutlinedInput)<OutlinedInputProps>(() => ({
  borderRadius: borderRadius.medium,
  backgroundColor: colors.background.paper,
  '& .MuiOutlinedInput-root': {
    borderRadius: borderRadius.medium,
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.primary.main,
    },
  },
}));

// Select estilizado
export const StyledSelect = styled(Select)<SelectProps>(() => ({
  borderRadius: borderRadius.medium,
  '& .MuiOutlinedInput-root': {
    borderRadius: borderRadius.medium,
  },
}));

// Botão principal estilizado
export const PrimaryButton = styled(Button)<ButtonProps>(() => ({
  borderRadius: borderRadius.medium,
  textTransform: 'none',
  fontWeight: 600,
  padding: `${spacing.md} ${spacing.xl}`,
  background: colors.primary.main,
  boxShadow: 'none',
  '&:hover': {
    background: colors.primary.dark,
    boxShadow: 'none',
  },
}));

// Botão secundário estilizado
export const SecondaryButton = styled(Button)<ButtonProps>(() => ({
  borderRadius: borderRadius.medium,
  textTransform: 'none',
  fontWeight: 600,
  padding: `${spacing.md} ${spacing.lg}`,
}));

// Container de formulário
export const FormContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.md,
}));

// Container de ações
export const ActionsContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: spacing.md,
  paddingTop: spacing.md,
  '& > *:first-child': {
    marginRight: 'auto',
  },
}));

// Paper estilizado para páginas internas
export const StyledPaper = styled(Paper)<PaperProps>(() => ({
  padding: spacing.xl,
  borderRadius: borderRadius.large,
  boxShadow: 'none',
  background: colors.background.paper,
  border: '1px solid #e0e0e0',
}));

// Container de página
export const PageContainer = styled(Box)(() => ({
  padding: spacing.lg,
  minHeight: '100vh',
  background: colors.background.default,
}));

// Header de página
export const PageHeader = styled(Box)(() => ({
  marginBottom: spacing.xl,
  textAlign: 'center',
}));

// Wrapper de conteúdo
export const ContentWrapper = styled(Box)(() => ({

  margin: '0 auto',
  width: '100%',
}));